export interface HeroConfig {
  title: {
    main: string;
    highlight: string;
  };
  description: string;
  buttons: {
    primary: {
      text: {
        mobile: string;
        desktop: string;
      };
      href: string;
      icon: string;
    };
    secondary: {
      text: string;
      href: string;
    };
  };
  stats: Array<{
    icon: string;
    text: string;
  }>;
  features: Array<{
    icon: string;
    title: string;
    description: string;
    gradient: string;
  }>;
}

export const heroConfig: HeroConfig = {
  title: {
    main: "Des Fêtes",
    highlight: "Inoubliables"
  },
  description: "Louez nos châteaux gonflables et sumos pour des moments magiques ! Parfait pour anniversaires, mariages et événements en Belgique.",
  buttons: {
    primary: {
      text: {
        mobile: "Réserver",
        desktop: "Demande de Réservation"
      },
      href: "#contact",
      icon: "🎉"
    },
    secondary: {
      text: "Voir nos Châteaux",
      href: "/chateaux"
    }
  },
  stats: [
    {
      icon: "Users",
      text: "1000+ Événements"
    },
    {
      icon: "MapPin", 
      text: "Retrait Rhode-Saint-Genèse"
    },
    {
      icon: "Clock",
      text: "À partir de 30€"
    }
  ],
  features: [
    {
      icon: "🏰",
      title: "Châteaux Gonflables",
      description: "Thèmes variés, sécurisés et amusants",
      gradient: "gradient-primary"
    },
    {
      icon: "🤼",
      title: "Sumos", 
      description: "Combat amusant pour tous les âges",
      gradient: "gradient-fun"
    },
    {
      icon: "🚗",
      title: "Transport Facile",
      description: "Rentre dans voiture avec hayon",
      gradient: "bg-secondary"
    },
    {
      icon: "💰",
      title: "Petits Prix",
      description: "À partir de 30€ seulement",
      gradient: "bg-accent"
    }
  ]
};